const getUserLocation = () => {
  const SLLocation = Mach.requireModule('SLLocation');
  return SLLocation.getLocation();
};

export { getUserLocation };
